import { render, staticRenderFns } from "./DialogEditVesselDocument.vue?vue&type=template&id=5452e6ed&"
import script from "./DialogEditVesselDocument.vue?vue&type=script&lang=js&"
export * from "./DialogEditVesselDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports